
import {map,  concatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { GISConfig } from '../models/gis-config.model';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { GisTokenService } from './gis-token.service';
import { Observable, from } from 'rxjs';

@Injectable()
export class LunaGisLayersService {
    public _config: GISConfig;

    constructor(
        public _httpClient: HttpClient,
        public _tokenService: GisTokenService
    ) {
        this._config = window['GIS.Conf'] as GISConfig;
    }

    getPortalCatalog() {
        return from(this._tokenService.getToken()).pipe(concatMap(token => {
            return this._httpClient.get<any>(this._config.restServicesUrl,
                {
                    params: {
                        option: 'footprints',
                        f: 'json',
                        token: token
                    }
                }
            ).pipe(map(x => x.featureCollection.layers[0]));
        }));
    }

    getServiceLayers(url: string) {
        if (url.indexOf('gis.rics-jmt.net') !== -1)
            return from(this._tokenService.getToken()).pipe(concatMap(token => {
                return this._httpClient.get<any>(url, {
                    params: {
                        f: 'json',
                        token: token
                    }
                });
            }));
        else
            return this._httpClient.get<any>(url, {
                params: {
                    f: 'json',
                }
            });
    }
}
